export const routeStatus = {
  ABNORMAL_FEEDBACK: "异常反馈",
  CANCELED: "订单已取消",
  DISPATCHING: "订单待调度",
  OTHER: "其他",
  RECEIVED_ORDER: " 骑手已接单",
  REJECT: "拒收",
  SENDBACK_SUCCESS: "退回签收成功",
  SEND_ARRIVE: "到达",
  SEND_BACK: "退回",
  SEND_FAIL: "派送失败",
  SEND_ING: "运输中",
  SEND_OFF: "揽收",
  SEND_ON: "转寄",
  SEND_PIECES: "派送",
  SEND_SUCCESS: "签收",
  SIGN_FAIL: "签收失败",
};
